<template>
    <div class="modal-base edit-address">
        <!-- <div class="remark-for-name">
            <span>*</span>กรุณากรอก ชื่อ-นามสกุลจริง เพื่อใช้ในการรับของรางวัล
        </div> -->
        <div class="modal-base-body pb-4 box-address">
            <FormAddress
                ref="form-address"
                @onFormChange="clickEditAddress($event)"
            ></FormAddress>
        </div>
        <div class="modal-base-footer-adress row box-footer">
            <div class="btn-submit-wrapper">
                <div class="btn-submit" :class="{ disabled: isDisabledSubmit }">
                    บันทึก
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Account from "@/helper/AccountHelper.js";
// import Util from "@/helper/Utility.js";
import Locale from "@/helper/locale/locale.js";
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import FormAddress from "@/module/Address/DeliveryAddress/component/FormAddress.vue";
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
import { AddressListModel } from "@/core/Address/model/AddressListModel.js";

/**
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "AddAddressModal",
    mixins: [ErrorApiMixin],
    components: {
        FormAddress
    },
    props: {
        controller: Object,
        modalId: String
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            isDisabledSubmit: true
        };
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        show: function() {
            this.addressModel = this.controller.address;
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        clickSave: function() {
            var addressModel = this.$refs["form-address"].submitForm();
            if (addressModel != null) {
                let token = Account.getToken();
                let params = addressModel.getParams();

                this.controller.loadingModal.show();
                BzbsProfile.updateProfile(token, params).subscribe(
                    data => {
                        this.controller.loadingModal.hide();

                        let address = new AddressListModel();
                        address.setValueFormApi(data);

                        this.saveSuccess(address);
                    },
                    err => {
                        this.controller.loadingModal.hide();
                        this.errorResponse(err);
                    }
                );
            }
        },
        clickEditAddress: function(address) {
            this.editAddressModal
                .clearModal()
                .setAddress(address)
                .show();
            this.editAddressModal.onEditSuccess(() => {
                this.reloadAddressList();
            });
        },
        saveSuccess: function(address) {
            this.hide();
            this.controller.sendCallbackAddSuccess(address);
        }
    }
};
</script>
<style lang="scss">
@import "@/style/modal.scss";
.modal-add-address {
    @extend %modal-base;
}
.edit-address {
    .box-footer {
        padding: 0 10px 40px;
    }
    .box-address {
        padding: 0 10px;
    }
    .box-checkbox {
        padding: 10px 0px 0;
    }
    .wrap-input .label {
        color: #666666;
        font-size: 15px;
        font-weight: 300;
        font-family: "KanitLight";
    }
    .wrap-input .input-box .input-field {
        border: 1px solid #cccccc;
        padding: 0 15px;
        border-radius: 27px;
    }
    .wrap-input .input-box .placeholder {
        padding: 0 15px;
    }
    .input-box-error .ddl-input .btn-ddl-input {
        border: 1px solid #f00 !important;
        color: #f00 !important;
    }
    .wrap-input .label.error {
        color: #666666 !important;
    }
    .box-checkbox .text-label-check {
        font-size: 14px;
        font-family: "KanitRegular";
        color: #333333;
        font-weight: normal;
    }
    .remark-for-name {
        text-align: center;
        font-size: 18px;
        color: #044437;
        margin-bottom: -7px;
    }
    .remark-for-name span {
        color: #f47250;
    }
}
.modal-base-footer-adress {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn-submit-wrapper {
        width: 90%;
        .btn-submit {
            text-align: center;
            color: #fff;
            background: #6ba73c;
            padding: 0;
            border-radius: 25px;
            // box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
            font-size: 16px;
            height: 45px;
            line-height: 45px;
            &.disabled {
                // opacity: 0.3;
                background: #d8d8d8;
                pointer-events: none;
            }
        }
    }
}
</style>
